import { ObservableFromFetch } from "../ObservableFromFetch"
import { SetTestDetailVendorParameters } from "./SSOOrderRequest"

export default function OrderUpdate(parameters: SetTestDetailVendorParameters) {
  const requestBody: string = JSON.stringify(parameters)
  return ObservableFromFetch<string>("WorkforceOrder/UpdateOrder", requestBody)
}
